import React from "react";
import ReactDOM from "react-dom";
import App from "./apps/App";
import reportWebVitals from "./reportWebVitals";

import "styles/normalize.css";
import "styles/index.css";
import "gridjs/dist/theme/mermaid.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
